/**
 * Public Basket Manager
 * Sepet işlemleri için merkezi JavaScript yöneticisi
 */

(function () {
  "use strict";

  // ─────────────────────────────────────────────────────────
  // YARDIMCI FONKSİYONLAR
  // ─────────────────────────────────────────────────────────

  // icon: "success" | "error" | "info" | "warning"
  function showToast(icon, title, text) {
    var T = window.Toast;
    if (!T) return;
    var message = text && text.trim() ? text : title;
    var toastTitle = text && text.trim() ? title : "";
    if (icon === "success") T.success(toastTitle, message);
    else if (icon === "error") T.error(toastTitle, message);
    else T.info(toastTitle, message);
  }

  function showAlert(icon, title, text, onConfirm) {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      confirmButtonText: "Tamam",
      buttonsStyling: false,
      customClass: {
        popup: "swal2-custom-popup",
        title: "swal2-custom-title",
        htmlContainer: "swal2-custom-html",
        confirmButton: "swal2-confirm-custom",
      },
    }).then(function (result) {
      if (onConfirm && result.isConfirmed) onConfirm();
    });
  }

  // Header sepet özetini yenile
  function refreshBasketHeader() {
    var $wrapper = $("#basket-summary-wrapper");
    if ($wrapper.length) {
      $wrapper.load("/GetBasketSummary");
    }
  }

  // Sepet sayfasındaki özet panelini yenile
  function refreshCartSummaryPanel() {
    var $container = $("#cart-summary-container");
    if ($container.length) {
      $container.load("/GetCartSummary");
    }
  }

  // Kurs detay sayfasındaki butonları yenile
  function refreshCourseActionButtons() {
    var $wrapper = $("#course-action-buttons-wrapper");
    if ($wrapper.length) {
      var slug = $wrapper.data("slug");
      if (slug) {
        $wrapper.load("/Egitimler/ActionButtons/" + slug);
      }
    }
  }

  // ─────────────────────────────────────────────────────────
  // API ÇAĞRILARI
  // ─────────────────────────────────────────────────────────

  var BasketPublic = {
    /**
     * Sepete ürün ekleme
     */
    addToCart: function (courseId, onSuccess, onError) {
      $.ajax({
        url: "/AddToCart",
        type: "POST",
        data: { courseId: courseId },
        success: function (response) {
          if (response.success) {
            refreshBasketHeader();
            refreshCourseActionButtons();
            if (onSuccess) onSuccess(response);
            else {
              Swal.fire({
                title: "Harika Seçim!",
                text: "Eğitim başarıyla sepetinize eklendi.",
                icon: "success",
                iconColor: "#10b981",
                showCancelButton: true,
                confirmButtonText: "Sepete Git",
                cancelButtonText: "Alışverişe Devam Et",
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                  popup: "swal2-custom-popup",
                  title: "swal2-custom-title",
                  htmlContainer: "swal2-custom-html",
                  confirmButton: "swal2-confirm-custom",
                  cancelButton: "swal2-cancel-custom",
                },
              }).then(function (r) {
                if (r.isConfirmed) window.location.href = "/sepetim";
              });
            }
          } else {
            if (onError) onError(response);
            else showAlert("warning", "Bilgi", response.message || "İşleminiz şu anda gerçekleştirilemiyor.");
          }
        },
        error: function (xhr) {
          if (xhr.status === 401) {
            Swal.fire({
              icon: "info",
              title: "Oturum Açmanız Gerekiyor!",
              text: "Bu işlemi gerçekleştirmek için lütfen hesabınıza giriş yapın.",
              iconColor: "#3b82f6",
              showCancelButton: true,
              confirmButtonText: "Giriş Yap",
              cancelButtonText: "İptal",
              buttonsStyling: false,
              reverseButtons: true,
              customClass: {
                popup: "swal2-custom-popup",
                title: "swal2-custom-title",
                htmlContainer: "swal2-custom-html",
                confirmButton: "swal2-confirm-custom",
                cancelButton: "swal2-cancel-custom",
              },
            }).then(function (r) {
              if (r.isConfirmed) {
                window.location.href = "/giris?returnUrl=" + encodeURIComponent(window.location.pathname);
              }
            });
            
            if (onError) onError(xhr);
          } else {
            if (onError) onError(xhr);
            else showToast("error", "İşlem Başarısız", "Sistemsel bir hata oluştu, lütfen sayfayı yenileyip tekrar deneyin.");
          }
        },
      });
    },

    /**
     * Sepetten ürün çıkarma
     */
    removeFromCart: function (basketItemId, onSuccess, onError) {
      $.ajax({
        url: "/RemoveFromCart",
        type: "POST",
        data: { basketItemId: basketItemId },
        success: function (response) {
          if (response.success) {
            if (onSuccess) onSuccess(response);
          } else {
            if (onError) onError(response);
            else showAlert("error", "İşlem Başarısız", response.message || "Eğitim sepetten çıkarılırken bir sorun oluştu.");
          }
        },
        error: function (xhr) {
          if (onError) onError(xhr);
          else showToast("error", "Bağlantı Hatası", "Sunucu ile iletişim kurulamadı. Lütfen internet bağlantınızı kontrol edin.");
        },
      });
    },

    /**
     * Promosyon kodu uygulama
     */
    applyPromotion: function (code, onSuccess, onError) {
      $.ajax({
        url: "/ApplyPromotion",
        type: "POST",
        data: { code: code },
        success: function (response) {
          if (response.success) {
            refreshCartSummaryPanel();
            refreshBasketHeader();
            if (onSuccess) onSuccess(response);
            else showToast("success", "Tebrikler!", "İndirim kodunuz başarıyla uygulandı.");
          } else {
            if (onError) onError(response);
            else showToast("error", "Geçersiz Kod", response.message || "Girdiğiniz indirim kodu geçersiz veya süresi dolmuş.");
          }
        },
        error: function (xhr) {
          if (onError) onError(xhr);
          else showToast("error", "İşlem Başarısız", "Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
        },
      });
    },

    /**
     * Promosyon kodunu kaldırma
     */
    removePromotion: function (onSuccess, onError) {
      $.ajax({
        url: "/RemovePromotion",
        type: "POST",
        success: function (response) {
          if (response.success) {
            refreshCartSummaryPanel();
            refreshBasketHeader();
            if (onSuccess) onSuccess(response);
            else showToast("info", "İndirim Kaldırıldı", "Uygulanan indirim sepetinizden çıkarıldı.");
          } else {
            if (onError) onError(response);
            else showToast("error", "İşlem Başarısız", response.message || "İndirim sepetten kaldırılamadı.");
          }
        },
        error: function (xhr) {
          if (onError) onError(xhr);
          else showToast("error", "İşlem Başarısız", "Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
        },
      });
    },

    /**
     * Ödeme sayfasına yönlendirme
     */
    completeCheckout: function () {
      window.location.href = "/sepet/odeme-yontemi";
    },

    // ─────────────────────────────────────────────────────────
    // SATIN ALINMIŞ KURSLAR KONTROLÜ (LOCALSTORAGE + API)
    // ─────────────────────────────────────────────────────────
    syncPurchasedCourses: function () {
      var isAuthElement = document.querySelector('meta[name="user-auth-status"]');
      var isAuth = isAuthElement ? isAuthElement.getAttribute("content") === "true" : false;

      if (!isAuth) {
        localStorage.removeItem("menta_active_courses");
        localStorage.removeItem("menta_active_courses_time");
        // Eski cache key'ini de temizle (migration)
        localStorage.removeItem("menta_purchased_courses");
        localStorage.removeItem("menta_purchased_courses_time");
        return;
      }

      var cached = localStorage.getItem("menta_active_courses");
      var lastFetch = localStorage.getItem("menta_active_courses_time");
      var now = new Date().getTime();

      // Cache süresi: 5 dakika (300000 ms) — iade senaryoları için daha kısa tutuldu
      if (cached && lastFetch && now - parseInt(lastFetch) < 300000) {
        try {
          var courseIds = JSON.parse(cached);
          BasketPublic.updateUIWithPurchasedCourses(courseIds);
        } catch (e) {
          /* parse hatası sessizce geçilir */
        }
      } else {
        $.ajax({
          url: "/Panel/GetDashboardCourses",
          type: "GET",
          success: function (resp) {
            if (resp.success && resp.data) {
              // Sadece aktif erişimi olan, iade edilmemiş kurslar
              var activeCourseIds = resp.data
                .filter(function (c) {
                  return c.hasAccess === true && c.isRefunded !== true;
                })
                .map(function (c) {
                  return c.courseId;
                });
              localStorage.setItem("menta_active_courses", JSON.stringify(activeCourseIds));
              localStorage.setItem("menta_active_courses_time", now.toString());
              BasketPublic.updateUIWithPurchasedCourses(activeCourseIds);
            }
          },
        });
      }
    },

    updateUIWithPurchasedCourses: function (courseIds) {
      if (!courseIds || !courseIds.length) return;

      courseIds.forEach(function (id) {
        var $btn = $(".btn-add-to-cart[data-id='" + id + "']");
        if ($btn.length) {
          $btn
            .removeClass(
              "btn-add-to-cart bg-[var(--theme-primary)]/10 hover:bg-[var(--theme-primary)] hover:text-white text-[var(--theme-primary)] hover:!bg-[var(--theme-primary)] hover:!text-white",
            )
            .addClass("btn-owned bg-slate-100 text-slate-500 cursor-not-allowed")
            .prop("disabled", true)
            .css({ border: "none", "pointer-events": "none" })
            .html('<i class="bx bx-check-circle text-base"></i> Satın Alındı');
        }

        var $buyBtn = $(".btn-buy-now[data-id='" + id + "']");
        if ($buyBtn.length) {
          $buyBtn
            .removeClass(
              "btn-buy-now bg-[var(--theme-primary)] hover:bg-[var(--theme-primary-dark)] text-white hover:!bg-[var(--theme-primary)] hover:!text-white",
            )
            .addClass("btn-owned bg-slate-200 text-slate-500 cursor-not-allowed")
            .prop("disabled", true)
            .css({ border: "none", "pointer-events": "none" })
            .html('<i class="bx bx-check-circle text-base"></i> Satın Alındı');
        }
      });
    },

    // ─────────────────────────────────────────────────────────
    // EVENT LISTENER'LAR
    // ─────────────────────────────────────────────────────────
    init: function () {
      this.syncPurchasedCourses();

      // ── Sepet Sayfası: Promosyon Uygula ──────────────────
      $(document).on("click", "#btnApplyPromotion", function () {
        var code = $("#promotionCode").val();
        var $btn = $(this);
        if (!code || !code.trim()) {
          showToast("warning", "Bilgi Gerekli", "Lütfen geçerli bir indirim kodu girin.");
          return;
        }
        $btn.prop("disabled", true).text("...");
        BasketPublic.applyPromotion(
          code,
          function (response) {
            $btn.prop("disabled", false).text("Uygula");
            showToast("success", "Tebrikler!", "İndirim kuponu başarıyla uygulandı.");
          },
          function (err) {
            $btn.prop("disabled", false).text("Uygula");
            var msg = "Girdiğiniz indirim kodu geçersiz veya süresi dolmuş.";
            if (err && err.message) msg = err.message;
            else if (err && err.responseJSON && err.responseJSON.message) msg = err.responseJSON.message;
            showToast("error", "İşlem Başarısız", msg);
          },
        );
      });

      // ── Sepet Sayfası: Promosyon Kaldır ──────────────────
      $(document).on("click", "#btnRemovePromotion", function () {
        Swal.fire({
          title: "İndirimi İptal Et",
          text: "Sepetinize uygulanan indirim kodunu kaldırmak istediğinize emin misiniz?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Evet, Kaldır",
          cancelButtonText: "Vazgeç",
          buttonsStyling: false,
          reverseButtons: true,
          allowOutsideClick: false,
          customClass: {
            popup: "swal2-custom-popup",
            title: "swal2-custom-title",
            htmlContainer: "swal2-custom-html",
            confirmButton: "swal2-confirm-custom swal2-confirm-danger",
            cancelButton: "swal2-cancel-custom",
          },
        }).then(function (result) {
          if (result.isConfirmed) {
            BasketPublic.removePromotion();
          }
        });
      });

      // ── Sepet Sayfası: Ürün Sil ──────────────────────────
      $(document).on("click", ".btnRemoveCart", function () {
        var basketItemId = $(this).data("basket-item-id");
        var $cartItem = $(this).closest(".cart-item, [data-item-id]");

        if (!basketItemId) {
          showAlert("error", "Teknik Sorun", "Ürün bilgisine ulaşılamadı. Lütfen sayfayı yenileyip tekrar deneyin.");
          return;
        }

        // Optimistic UI — anında gizle
        $cartItem.css({ opacity: "0", transform: "scale(0.95)", transition: "all 0.2s ease" });

        BasketPublic.removeFromCart(
          basketItemId,
          // Başarılı
          function () {
            $cartItem.remove();

            // Kalan item sayısını kontrol et
            var remaining = $("#cart-items-container .cart-item, #cart-items-container [data-item-id]").length;

            // Header'ı güncelle
            refreshBasketHeader();

            if (remaining === 0) {
              // Sepet tamamen boş — layout'u değiştir
              $("#cart-layout-wrapper").remove();
              if ($("#empty-cart-state").length === 0) {
                $("#cart-page").append(
                  '<div id="empty-cart-state" class="text-center py-20 w-full">' +
                    '<i class="bx bx-shopping-bag" style="font-size:5rem;color:#cbd5e1;"></i>' +
                    '<h2 style="font-size:1.5rem;font-weight:700;margin-top:1rem;">Sepetiniz şu an boş</h2>' +
                    '<p style="color:#94a3b8;margin-bottom:1.5rem;">Henüz bir eğitim eklemediniz.</p>' +
                    '<a href="/egitimler" class="btn btn-primary">Eğitimleri Keşfet</a>' +
                    "</div>",
                );
              }
            } else {
              // Başka item'lar var — sadece özet panelini güncelle
              refreshCartSummaryPanel();
            }

            showToast("success", "Başarılı", "Seçili eğitim sepetinizden çıkarıldı.");
          },
          // Hata — item'ı geri göster
          function (err) {
            $cartItem.css({ opacity: "1", transform: "scale(1)" });
            var msg = "Eğitim sepetten çıkarılırken bir sorun oluştu.";
            if (err && err.message) msg = err.message;
            else if (err && err.responseJSON && err.responseJSON.message) msg = err.responseJSON.message;
            showAlert("error", "İşlem Başarısız", msg);
          },
        );
      });

      // ── Sepet Sayfası: Ödemeye Geç ───────────────────────
      $(document).on("click", "#btnCompleteCheckout", function () {
        BasketPublic.completeCheckout();
      });

      // ── Header Dropdown: Ürün Sil ─────────────────────────
      $(document).on("click", ".cart-item-remove", function () {
        var basketItemId = $(this).data("id");
        var courseId = $(this).data("course-id");

        Swal.fire({
          title: "Sepetten Çıkar",
          text: "Bu eğitimi sepetinizden kaldırmak istediğinize emin misiniz?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Evet, Kaldır",
          cancelButtonText: "Vazgeç",
          buttonsStyling: false,
          reverseButtons: true,
          allowOutsideClick: false,
          customClass: {
            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-html",
            confirmButton: "swal2-confirm-custom",
            cancelButton: "swal2-cancel-custom",
          },
        }).then(function (result) {
          if (result.isConfirmed) {
            BasketPublic.removeFromCart(
              basketItemId,
              function () {
                // Eğer /sepetim sayfasındaysak, sayfayı yenile
                if (window.location.pathname.toLowerCase() === "/sepetim") {
                  refreshBasketHeader();
                  // Kısa gecikme sonra yenile — header güncellenmesi için zaman ver
                  setTimeout(function () {
                    window.location.reload();
                  }, 300);
                  return;
                }

                // Diğer sayfalarda: header güncelle, kurs butonunu resetle
                refreshBasketHeader();

                if (courseId) {
                  window.dispatchEvent(new CustomEvent("basket:itemRemoved", { detail: { courseId: courseId } }));
                }

                Swal.fire({
                  icon: "success",
                  title: "Başarılı",
                  text: "Eğitim sepetinizden çıkarıldı.",
                  timer: 2000,
                  showConfirmButton: false,
                  buttonsStyling: false,
                  customClass: { popup: "swal2-custom-popup" },
                });
              },
              function () {
                showAlert("error", "İşlem Başarısız", "Eğitim sepetten çıkarılırken teknik bir sorun oluştu. Lütfen biraz sonra tekrar deneyin.");
              },
            );
          }
        });
      });

      // ── Kurs Detay Sayfası: Sepete Ekle ──────────────────
      $(document).on("click", ".btn-add-to-cart", function () {
        var courseId = $(this).data("id");
        var $btn = $(this);
        var originalHtml = $btn.html();

        $btn.prop("disabled", true).html('<i class="bx bx-loader-alt bx-spin"></i> Ekleniyor...');

        BasketPublic.addToCart(
          courseId,
          function (response) {
            // GTM add_to_cart olayını tetikle
            window.dataLayer = window.dataLayer || [];
            var courseTitle = $btn.data("title") || document.title || "Eğitim";
            var coursePrice = $btn.data("price");
            var pushData = {
              event: "add_to_cart",
              meta_content_ids: [String(courseId)],
              meta_content_name: courseTitle,
              meta_content_type: "product",
              meta_event_id: (typeof window.mentaEventId === "function" ? window.mentaEventId("cart") : "cart-" + Date.now())
            };
            if (coursePrice !== undefined && coursePrice !== null && !isNaN(parseFloat(coursePrice))) {
              pushData.meta_value = parseFloat(coursePrice);
              pushData.meta_currency = "TRY";
            }
            window.dataLayer.push(pushData);

            // Başarılı olduğunda Sidebar zaten refreshCourseActionButtons ile otomatik yenileniyor.
            // addToCart içinde refreshCourseActionButtons ve refreshBasketHeader zaten çağrılıyor.

            Swal.fire({
              title: "Harika Seçim!",
              text: "Eğitim başarıyla sepetinize eklendi.",
              icon: "success",
              iconColor: "#10b981",
              showCancelButton: true,
              confirmButtonText: "Sepete Git",
              cancelButtonText: "Alışverişe Devam Et",
              buttonsStyling: false,
              reverseButtons: true,
              customClass: {
                popup: "swal2-custom-popup",
                title: "swal2-custom-title",
                htmlContainer: "swal2-custom-html",
                confirmButton: "swal2-confirm-custom",
                cancelButton: "swal2-cancel-custom",
              },
            }).then(function (r) {
              if (r.isConfirmed) {
                window.location.href = "/sepetim";
              } else {
                // Dinamik olarak "Sepete Git" butonuna dönüştür
                $btn.prop("disabled", false)
                    .removeClass("btn-add-to-cart")
                    .addClass("btn-go-to-cart btn-in-cart")
                    .html('<i class="bx bx-basket"></i> Sepete Git');
              }
            });
          },
          function (err) {
            if (err && err.status === 401) {
              $btn.prop("disabled", false).html(originalHtml);
              return;
            }

            var message =
              err && err.message
                ? err.message
                : err && err.responseJSON
                  ? err.responseJSON.message
                  : "Sistemde geçici bir sorun oluştu. Lütfen daha sonra tekrar deneyin.";

            showAlert("warning", "Bilgi", message);
            $btn.prop("disabled", false).html(originalHtml);
          },
        );
      });

      // ── Kurs Detay Sayfası: Sepete Git (dinamik) ─────────
      $(document).on("click", ".btn-go-to-cart, .btn-go-to-checkout", function () {
        window.location.href = "/sepetim";
      });

      // ── Kurs Detay Sayfası: Hemen Satın Al ───────────────
      $(document).on("click", ".btn-buy-now", function () {
        var courseId = $(this).data("id");
        var $btn = $(this);
        var originalHtml = $btn.html();

        $btn.prop("disabled", true).html('<i class="bx bx-loader-alt bx-spin"></i>');

        BasketPublic.addToCart(
          courseId,
          function () {
            window.location.href = "/sepetim";
          },
          function (err) {
            if (err && err.status === 401) {
              $btn.prop("disabled", false).html(originalHtml);
              return;
            }

            var message =
              err && err.message
                ? err.message
                : err && err.responseJSON
                  ? err.responseJSON.message
                  : "Sistemde geçici bir sorun oluştu. Lütfen daha sonra tekrar deneyin.";

            showAlert("warning", "Bilgi", message);
            $btn.prop("disabled", false).html(originalHtml);
          },
        );
      });
      // ── Global: Sepetten Çıkarıldığında Butonları Resetle ─────────
      window.addEventListener("basket:itemRemoved", function (e) {
        if (e.detail && e.detail.courseId) {
          var courseId = e.detail.courseId;
          var $btns = $(".btn-in-cart[data-id='" + courseId + "']");
          if ($btns.length) {
            $btns
              .removeClass("btn-go-to-cart btn-in-cart")
              .addClass("btn-add-to-cart")
              .html('<i class="bx bx-cart-add"></i> Sepete Ekle');
          }
        }
      });
    },
  };

  // DOM hazır olduğunda başlat
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      BasketPublic.init();
    });
  } else {
    BasketPublic.init();
  }

  // Global erişim
  window.BasketPublic = BasketPublic;
})();
